import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  Box,
  Divider,
  IconButton,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { useState } from "react";
import CoreSpinner from "../../../app/core/components/CoreSpinner/CoreSpinner";
import { formatDDMmmYYYYHHMM } from "../../../utils/functions/date-utils";
import CoreDialog from "../../../app/core/components/CoreDialog/CoreDialog";
import { t } from "i18next";

const ChatArchiveTable = ({
  conversations = [],
  onOpen,
  onDelete,
  loading,
}) => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedConv, setSelectedConv] = useState(null);

  const handleDelete = (conv) => {
    setSelectedConv(conv);
    setOpenDialog(true);
  };

  const confirmDelete = () => {
    onDelete && onDelete(selectedConv);
    setOpenDialog(false);
  };

  const conversationTitle = (conv, i) => {
    return (
      conv.title || `Chat · ${formatDDMmmYYYYHHMM(conv.updatedAt) || i + 1}`
    );
  };

  if (loading) {
    return <CoreSpinner />;
  }

  return (
    <TableContainer
      className=" rounded-lg "
      style={{
        border: "1px solid lightgrey",
        transition: "width 0.3s",
        maxHeight: "58rem",
      }}
    >
      <Table>
        <TableHead>
          <TableRow style={{ backgroundColor: "#e6e6e6" }}>
            <TableCell>{t("Conversazioni")}</TableCell>
            <TableCell></TableCell>
            <TableCell>{t("Actions")}</TableCell>
          </TableRow>
        </TableHead>
        {conversations?.map((conv, i) => (
          <TableRow key={conv.id}>
            <TableCell>
              {" "}
              <Tooltip title={conversationTitle(conv, i)}>
                <p className=" m-0 py-3 font-medium text-gray-700 ">
                  {conv.title ||
                    `Chat · ${formatDDMmmYYYYHHMM(conv.updatedAt) || i + 1}`}
                </p>
              </Tooltip>
            </TableCell>
            <TableCell>
              <Box display="flex" alignItems="center">
                <Divider orientation="vertical" flexItem sx={{ height: 24 }} />
              </Box>
            </TableCell>
            <TableCell>
              <div className="flex">
                <Tooltip title="Apri">
                  <IconButton
                    color="primary"
                    onClick={() => onOpen && onOpen(conv)}
                  >
                    <SearchRoundedIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Elimina">
                  <IconButton color="error" onClick={() => handleDelete(conv)}>
                    <DeleteRoundedIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </TableCell>
          </TableRow>
        ))}
        {conversations?.length === 0 && (
          <TableRow>
            <TableCell colSpan={4} className="text-center text-gray">
              {t("NoArchiviedChat")}
            </TableCell>
          </TableRow>
        )}
      </Table>
      <CoreDialog
        open={openDialog}
        title={` Conferma eliminazione`}
        content={"Sei sicuro di voler eliminare questa conversazione?"}
        negativeButton={t("No")}
        positiveButton={t("Yes")}
        handlePositive={confirmDelete}
        closeDialog={() => setOpenDialog(false)}
      />
    </TableContainer>
  );
};

export default ChatArchiveTable;
